import { render } from "./DeptBoard.vue?vue&type=template&id=308d338c"
import script from "./DeptBoard.vue?vue&type=script&lang=js"
export * from "./DeptBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__